import { p as prisma } from "../../chunks/prisma.js";
import { redirect } from "@sveltejs/kit";
const load = (async ({ locals: { user }, url: { pathname } }) => {
  if (pathname === "/") redirect(303, "/product");
  if (user) {
    const loggedInUser = await prisma.user.findUnique({
      where: { id: user.id }
    });
    const activeSubscription = await prisma.userSubscription.findFirst({
      where: {
        userId: user.id,
        status: "ACTIVE",
        isActive: true,
        endsAt: {
          gte: /* @__PURE__ */ new Date()
          // still valid
        }
      },
      select: { id: true }
    });
    const isSubscribed = !!activeSubscription;
    return {
      user: loggedInUser,
      isSubscribed
    };
  }
  return { user: null, isSubscribed: false };
});
export {
  load
};
